import { ReactComponent as ClinicMembersIcon } from '../../../assets/svg/clinic-members.svg';

export default ClinicMembersIcon;
